
    <div dw-tooltip dwPlacement="topLeft" dwOverlayClassName="ag-invalid-cell-overlay"
         [dwTitle]="errorContent" [dwVisible]="errorVisible"
         *ngIf="errorVisible"></div>
    <ng-template #errorContent>
      <div *ngFor="let msg of validationMessages">{{ msg.key | translate:msg.params }}</div>
    </ng-template>
    <form [formGroup]="validateForm">
      <dw-form-control>
        <dw-input-group>
          <dw-select dw-input style="width: 100%"
                     [formControl]="formControl"
                     placeholder=""
                     [dwShowSearch]="dwShowSearch"
                     [dwAllowClear]="dwAllowClear"
                     #cellInput>
            <dw-option *ngFor="let item of values"
                       [dwValue]="item.value ? item.value : item"
                       [dwLabel]="item.label ? item.label : item"></dw-option>
          </dw-select>
        </dw-input-group>
      </dw-form-control>
    </form>
  